/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path apihooks
 * @description Notification about MyTasks
 * @section 4.2.1.4
 */
import { useAppContext } from "@qpr/client-api-base/context/AppCtxProvider";
import { useMeaModelId } from "@qpr/client-api-base/utils/model";
import axios from "axios";
import { useEffect } from "react";
import { useQuery, useQueryClient } from "react-query";
const useNotificationBell = (executeQuery: boolean = true) => {
  const qc = useQueryClient();
  const ctx = useAppContext();
  console.log("NOTIFICATION BELL");
  const { data: model, isLoading: modeLoading } = useMeaModelId(
    ctx.model || "DP2030"
  );
  const { data, isLoading, refetch } = useQuery(
    ["notification-bell-my-tasks"],
    () => {
      return axios.get("/workflow/mytasks", {
        params: {
          modelId: model?.data[0].id,
          include: "coming",
        },
      });
    },
    {
      enabled: executeQuery && !!model?.data[0]?.id,
      cacheTime: 300 * 60 * 1000,
      staleTime: 300 * 60 * 1000,
    }
  );
  const hasNotification = executeQuery
    ? !isLoading && data?.data.data.length > 0
    : null;
  const refresh = () => {
    qc.invalidateQueries("notification-bell-my-tasks");
    refetch();
  };
  useEffect(() => {
    if (model?.data[0]?.id) {
      refresh();
    }
  }, [ctx.model, model]);
  return { hasNotification, refresh };
};
export default useNotificationBell;
